/**
 * Created by caterina on 08-05-17.
 */
import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import {AuthenticationService} from '../services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthenticationService) { }

  canActivate() {
    if (this.authService.isLoggedIn()) {
      return true;
    }
    this.router.navigate(['/ingresar']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/guards/authentication-guard.ts